import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const EndUserRequestUpgradeModalEntrypoint: LoadableType<{
	source: string;
	handleCloseModal: () => void;
	setIsLoadingModal: (isLoading: boolean) => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndUserRequestUpgradeModal" */ './EndUserRequestUpgradeModal.tsx'
			)
		).EndUserRequestUpgradeModal,
});
